import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PictureFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.12 19.84V4.08H19.88V19.84H4.12ZM9.26 10.48C9.98 10.48 10.58 9.9 10.58 9.18C10.58 8.46 9.98 7.88 9.26 7.88C8.56 7.88 7.96 8.46 7.96 9.18C7.96 9.9 8.56 10.48 9.26 10.48ZM14.02 12.32L10.92 15.72L8.88 13.42L6.2 16.44H17.78L14.02 12.32Z" />
    </SvgIcon>
  );
});
